const ko = {
  common: {
    buttons: {
      edit: "수정",
      reset: "초기화",
      execute: "실행",
      write: "글작성",
      inventory: "목록",
      correction: "수정",
      delete: "삭제",
      cancel: "취소",
      save: "저장",
      login: "로그인",
      downloadExcel: "엑셀다운로드",
    },
    search: {
      placeholder: "검색어를 입력해주세요.",
    },
    file: {
      defaultPlaceholder: "파일을 선택해주세요.",
    },
    calendar: {
      month: "{{month}}월",
      day: {
        sun: "일",
        mon: "월",
        tue: "화",
        wed: "수",
        thu: "목",
        fri: "금",
        sat: "토",
      },
    },
    messages: {
      login: {
        notAuthenticated: "이 기능을 사용하려면 로그인하세요!",
      },
      boardItem: {
        putSuccess: "게시물이 등록되었습니다.",
        patchSuccess: "게시물이 수정되었습니다.",
        deleteTitle: "삭제하시겠습니까?",
        deleteConfirm: "삭제된 내용은 복원할 수 없습니다.",
        deleteSuccess: "게시물이 삭제되었습니다.",
        error: "오류가 발생했습니다.",
      },
    },
    text: {
      noData: "등록된 게시글이 없습니다.",
      bePreparing: "페이지 준비중입니다.",
    },
  },
};

export default ko;
